import React from 'react';
import Avatar from '../Avatar';
import {
  StyledBox,
  Title,
  TitleContainer,
  AvatarTitleWrap,
} from '../Search/styles';

const getAriaLabel = (
  disabled: boolean | undefined,
  isSelected: boolean,
  title: string,
) => {
  switch (true) {
    case disabled:
      return `${title} read only`;
    case isSelected:
      return `${title} selected`;
    default:
      return title;
  }
};

const SearchOptionCard = React.forwardRef<
  HTMLLIElement,
  React.HTMLProps<HTMLLIElement> & {
    avatarUrl?: string;
    disabled?: boolean;
    disabledText?: string;
    selected?: boolean;
    showAvatar?: boolean;
    subTitle?: string;
    title: string;
    type?: string;
  }
>(
  (
    {
      avatarUrl,
      disabled,
      disabledText,
      selected,
      showAvatar,
      subTitle,
      title,
      type,
      ...props
    },
    ref,
  ) => {
    const isSelected = Boolean(props['aria-selected']);
    return (
      <StyledBox
        component="li"
        ref={ref}
        disabled={disabled}
        aria-label={getAriaLabel(disabled, isSelected, title)}
        {...(props as React.HTMLAttributes<HTMLDivElement>)}
      >
        <AvatarTitleWrap disabled={disabled}>
          {showAvatar && <Avatar src={avatarUrl} alt={title} size="sm" />}
          <TitleContainer>
            <Title disabled={isSelected}>{title}</Title>
            {subTitle && (
              <Title sub disabled={isSelected}>
                {subTitle}
              </Title>
            )}
          </TitleContainer>
          <Title light disabled={isSelected}>
            {disabled ? disabledText : type}
          </Title>
        </AvatarTitleWrap>
      </StyledBox>
    );
  },
);

export default SearchOptionCard;
